import { Component } from 'react';
import { Field } from 'redux-form';

import { TextArea, CheckBox } from 'common/components/forms';

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNotes: (props.reservationCart && props.reservationCart.notes) || false
    };
  }

  handleNoteChange = (e) => {
    this.setState({ isNotes: e.target.checked });
  };

  render() {
    const { isNotes } = this.state;
    return (
      <>
        <Field
          name="isNotes"
          type="checkbox"
          component={CheckBox}
          onChange={this.handleNoteChange}
          value="1"
          label="Add notes or dietary restrictions"
        />
        {isNotes && (
          <Field
            name="notes"
            component={TextArea}
            label="Notes and dietary restrictions"
            rows={5}
          />
        )}
      </>
    );
  }
}

export default Notes;
